import { render, staticRenderFns } from "./label-slot.component.vue?vue&type=template&id=87088360&scoped=true&"
import script from "./label-slot.component.vue?vue&type=script&lang=ts&"
export * from "./label-slot.component.vue?vue&type=script&lang=ts&"
import style0 from "./label-slot.component.vue?vue&type=style&index=0&id=87088360&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87088360",
  null
  
)

export default component.exports